
import React from 'react'
import Icon from 'react-icon-base'

const FaPlayCircle = props => (
    <Icon viewBox="0 0 40 40" {...props}>
        <g><path d="m20.1 2.9q4.7 0 8.6 2.3t6.3 6.2 2.3 8.6-2.3 8.6-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3z m8.6 18.3q0.7-0.4 0.7-1.2t-0.7-1.2l-12.1-7.2q-0.7-0.4-1.5 0-0.7 0.4-0.7 1.3v14.2q0 0.9 0.7 1.3 0.4 0.2 0.8 0.2 0.3 0 0.7-0.2z"/></g>
    </Icon>
)

export default FaPlayCircle



// WEBPACK FOOTER //
// /codebuild/output/src1478882582/src/pobble-app/client/~/react-icons/fa/play-circle.js